import React from 'react';
import { AlertCircle, Check, Clipboard, Download, Terminal } from 'lucide-react';
import type { CommandBuildResult, ShellTarget } from '../lib/commandBuilder';

interface CommandPanelProps {
  result: CommandBuildResult;
  shell: ShellTarget;
  copied: boolean;
  onShellChange: (shell: ShellTarget) => void;
  onCopy: () => void;
  onDownload: () => void;
}

const CommandPanel: React.FC<CommandPanelProps> = ({ result, shell, copied, onShellChange, onCopy, onDownload }) => (
  <section className="command-panel" aria-label="FFmpeg 命令预览">
    <div className="command-panel__header">
      <div className="command-panel__title">
        <span className="command-panel__icon"><Terminal size={17} /></span>
        <div>
          <h2>FFmpeg 命令</h2>
          <span>实时生成 · 不会在浏览器中执行</span>
        </div>
      </div>
      <div className="command-panel__actions">
        <div className="shell-switch" role="group" aria-label="命令行环境">
          <button type="button" aria-pressed={shell === 'bash'} className={shell === 'bash' ? 'is-active' : ''} onClick={() => onShellChange('bash')}>Bash</button>
          <button type="button" aria-pressed={shell === 'powershell'} className={shell === 'powershell' ? 'is-active' : ''} onClick={() => onShellChange('powershell')}>PowerShell</button>
        </div>
        <button className="command-action" type="button" onClick={onDownload} disabled={!result.command} title="下载脚本">
          <Download size={15} /><span>下载</span>
        </button>
        <button className="command-action command-action--copy" type="button" onClick={onCopy} disabled={!result.command} data-state={copied ? 'success' : undefined}>
          {copied ? <Check size={15} /> : <Clipboard size={15} />}
          <span>{copied ? '已复制' : '复制命令'}</span>
        </button>
      </div>
    </div>
    {result.errors.length > 0 ? (
      <div className="command-problems" role="alert">
        {result.errors.map((error) => <p key={error}><AlertCircle size={15} /><span>{error}</span></p>)}
      </div>
    ) : (
      <pre className="command-code"><code>{result.command}</code></pre>
    )}
    {result.warnings.length > 0 && (
      <div className="command-warnings" role="status">
        {result.warnings.map((warning) => <span key={warning}>{warning}</span>)}
      </div>
    )}
  </section>
);

export default CommandPanel;
